import { Component } from '@angular/core';
import { NbDialogService } from '@nebular/theme';
import { ColorPickerComponent } from './color-picker.component';

@Component({
  selector: 'app-color-picker-demo',
  template: `
    <div class="demo-container">
      <h2>Color Picker Component Demo</h2>
      
      <div class="demo-section">
        <h3>Basic Color Picker</h3>
        <button class="demo-btn" (click)="openBasicPicker()">
          Open Color Picker
        </button>
        <div class="selected-color" *ngIf="selectedColor">
          <span>Selected Color: </span>
          <div class="color-preview" [style.background-color]="selectedColor"></div>
          <span class="color-code">{{ selectedColor }}</span>
        </div>
      </div>

      <div class="demo-section">
        <h3>Custom Title & Description</h3>
        <button class="demo-btn" (click)="openCustomPicker()">
          Open Custom Color Picker
        </button>
        <div class="selected-color" *ngIf="customSelectedColor">
          <span>Selected Color: </span>
          <div class="color-preview" [style.background-color]="customSelectedColor"></div>
          <span class="color-code">{{ customSelectedColor }}</span>
        </div>
      </div>

      <div class="demo-section">
        <h3>With Initial Color</h3>
        <button class="demo-btn" (click)="openInitialColorPicker()">
          Open with Initial Color
        </button>
        <div class="selected-color" *ngIf="initialSelectedColor">
          <span>Selected Color: </span>
          <div class="color-preview" [style.background-color]="initialSelectedColor"></div>
          <span class="color-code">{{ initialSelectedColor }}</span>
        </div>
      </div>

      <div class="demo-section">
        <h3>Color History Demo</h3>
        <p>Select colors multiple times to see them appear in the History tab. The history is automatically saved and persists across sessions.</p>
        <button class="demo-btn" (click)="openHistoryDemo()">
          Open Color Picker (Check History Tab)
        </button>
        <div class="selected-color" *ngIf="historyDemoColor">
          <span>Selected Color: </span>
          <div class="color-preview" [style.background-color]="historyDemoColor"></div>
          <span class="color-code">{{ historyDemoColor }}</span>
        </div>
      </div>


    </div>
  `,
  styles: [`
    .demo-container {
      padding: 20px;
      max-width: 800px;
      margin: 0 auto;
    }

    .demo-section {
      margin-bottom: 30px;
      padding: 20px;
      border: 1px solid #e0e0e0;
      border-radius: 8px;
      background-color: #f9f9f9;
    }

    .demo-section h3 {
      margin-top: 0;
      color: #333;
      border-bottom: 2px solid #007bff;
      padding-bottom: 10px;
    }

    .demo-btn {
      background-color: #007bff;
      color: white;
      border: none;
      padding: 10px 20px;
      border-radius: 4px;
      cursor: pointer;
      font-size: 14px;
      margin-bottom: 15px;
      transition: background-color 0.2s;
    }

    .demo-btn:hover {
      background-color: #0056b3;
    }

    .selected-color {
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 15px;
      background-color: white;
      border-radius: 4px;
      border: 1px solid #ddd;
    }

    .color-preview {
      width: 30px;
      height: 30px;
      border-radius: 4px;
      border: 2px solid #ddd;
    }

    .color-code {
      font-family: monospace;
      font-weight: bold;
      color: #333;
    }
  `]
})
export class ColorPickerDemoComponent {
  selectedColor = '';
  customSelectedColor = '';
  initialSelectedColor = '';
  historyDemoColor = '';

  constructor(private dialogService: NbDialogService) {}

  openBasicPicker(): void {
    const dialog = this.dialogService.open(ColorPickerComponent, {
      context: {
        title: 'Pick a color!',
        description: 'Choose from our predefined color palette or pick a custom color.'
      }
    });

    dialog.onClose.subscribe((result) => {
      if (result && result.status) {
        this.selectedColor = result.color;
      }
    });
  }

  openCustomPicker(): void {
    const dialog = this.dialogService.open(ColorPickerComponent, {
      context: {
        title: 'Choose Your Brand Color',
        description: 'Select a color that best represents your brand identity. This color will be used across your application.'
      }
    });

    dialog.onClose.subscribe((result) => {
      if (result && result.status) {
        this.customSelectedColor = result.color;
      }
    });
  }

  openInitialColorPicker(): void {
    const dialog = this.dialogService.open(ColorPickerComponent, {
      context: {
        title: 'Edit Color',
        description: 'Modify the current color selection',
        initialColor: '#3B82F6'
      }
    });

    dialog.onClose.subscribe((result) => {
      if (result && result.status) {
        this.initialSelectedColor = result.color;
      }
    });
  }

  openHistoryDemo(): void {
    const dialog = this.dialogService.open(ColorPickerComponent, {
      context: {
        title: 'Color Picker with History',
        description: 'Try selecting different colors and then check the History tab to see your recently used colors!'
      }
    });

    dialog.onClose.subscribe((result) => {
      if (result && result.status) {
        this.historyDemoColor = result.color;
      }
    });
  }
} 